export const VERIFY_EMAIL='VERIFY_EMAIL'
export const VERIFY_EMAIL_SUCCESS='VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_FAILURE='VERIFY_EMAIL_FAILURE'

export const OTP_VERIFY = 'OTP_VERIFY'
export const OTP_VERIFY_SUCCESS = 'OTP_VERIFY_SUCCESS'
export const OTP_VERIFY_FAILURE = 'OTP_VERIFY_FAILURE'